
















































import { Component, Vue } from 'vue-property-decorator'
import firstLevel from './firstLevel.vue'
import { vxm } from '@/store'

@Component({
  props: ['menu'],
  components: {
    firstLevel
  }
})
export default class MainNav extends Vue {
  get hideMobileNav() {
    return vxm.menu.hideMobileNav
  }
  set hideMobileNav(value) {
    vxm.menu.setMobileNav(value)
  }

  get isMobile() {
    return vxm.core.isMobile
  }

  get showFilter() {
    return vxm.packages.showFilter
  }

  set showFilter(value) {
    vxm.packages.setShowFilter(value)
  }
}
